import React from "react";

import MainContent from "../Home/MainContent";

const DashboardNC = () => {
  return <MainContent>DashboardNC</MainContent>;
};

export default DashboardNC;
